<div
  class="flex w-full flex-col items-start justify-start gap-12 bg-emerald-50 px-5 py-16 md:gap-20 md:px-16"
>
  <!-- Header Section -->
  <div
    class="flex flex-col items-start justify-start gap-5 self-stretch md:flex-row md:gap-24"
  >
    <div class="flex flex-col items-start justify-start gap-4 self-stretch">
      <h2
        class="text-4xl leading-tight font-medium text-primary-text md:text-5xl"
      >
        {{ 'components.ourSubscriptions.title' | translate }}
      </h2>
    </div>
    <!-- Disabled from design per request -->
    <!-- <div class="flex flex-col items-start justify-start gap-6 self-stretch md:flex-grow">
      <p class="text-lg font-medium leading-normal text-primary-text md:text-base md:font-normal">
        {{ 'components.ourSubscriptions.description' | translate }}
      </p>
    </div> -->
  </div>

  <!-- Subscription Cards -->
  <div
    class="flex flex-col items-center justify-start gap-12 self-stretch md:flex-row md:gap-24"
  >
    <!-- Journal Subscriptions -->
    <div
      class="flex flex-col items-start justify-start gap-6 self-stretch md:flex-grow md:gap-8"
    >
      <div
        class="flex flex-col items-start justify-start gap-3 self-stretch md:gap-6"
      >
        <div class="flex h-12 w-12 items-center justify-center p-1">
          <img
            class="h-10 w-10"
            src="../../../../../assets/icons/book-content.svg"
            alt="Journal Subscriptions Icon"
          />
        </div>
        <h3
          class="self-stretch text-xl leading-7 font-medium text-primary-text md:text-2xl md:leading-relaxed"
        >
          {{
            'components.ourSubscriptions.journalSubscriptions.title' | translate
          }}
        </h3>
        <!-- Disabled from design per request -->
        <!-- <p class="self-stretch text-base font-normal leading-normal text-primary-text">
          {{ 'components.ourSubscriptions.journalSubscriptions.description' | translate }}
        </p> -->
      </div>
      <div class="self-stretch pt-2">
        <button class="btn-primary btn" [routerLink]="['/', 'pricing']">
          {{
            'components.ourSubscriptions.journalSubscriptions.button'
              | translate
          }}
        </button>
      </div>
    </div>

    <!-- Bundle Subscriptions -->
    <div
      class="flex flex-col items-start justify-start gap-6 self-stretch md:flex-grow md:gap-8"
    >
      <div
        class="flex flex-col items-start justify-start gap-3 self-stretch md:gap-6"
      >
        <div class="flex h-12 w-12 items-center justify-center p-1">
          <img
            class="h-10 w-10"
            src="../../../../../assets/icons/book-alt.svg"
            alt="Bundle Subscriptions Icon"
          />
        </div>
        <h3
          class="self-stretch text-xl leading-7 font-medium text-primary-text md:text-2xl md:leading-relaxed"
        >
          {{
            'components.ourSubscriptions.bundleSubscriptions.title' | translate
          }}
        </h3>
        <!-- Disabled from design per request -->
        <!-- <p class="self-stretch text-base font-normal leading-normal text-primary-text">
          {{ 'components.ourSubscriptions.bundleSubscriptions.description' | translate }}
        </p> -->
      </div>
      <div class="self-stretch pt-2">
        <button class="btn-primary btn" [routerLink]="['/', 'pricing']">
          {{
            'components.ourSubscriptions.bundleSubscriptions.button' | translate
          }}
        </button>
      </div>
    </div>
  </div>
</div>
